import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import FuxOffsetPaginator from "../../../../../components/BaseComponents/FuxOffsetPaginator/FuxOffsetPaginator";
import ModalPortalHOC from "../../../../../components/BaseComponents/ModalPortalHOC";
import AwayTripListItem from "./AwayTripListItem";
import NewAwayTripPage from "./NewAwayTripPage";
import AwayTripDetailPage from "./AwayTripDetailPage";

export default class AwayTripsTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newTripOpen: false,
            detailTrip: null,
            selectedStaffId: props.staffList[0]?.id_dipendente || null
        };
        this.paginatorRef = React.createRef();
    }

    getStaffById = staffId => {
        if (!staffId) return null;
        return (this.props.staffList || []).find(s => String(s.id_dipendente) === String(staffId));
    }

    resetPaginator = _ => {
        if (this.paginatorRef.current && this.paginatorRef.current.reset) {
            this.paginatorRef.current.reset();
        }
    }

    handleNewTripOpen = _ => this.setState({newTripOpen: true});
    handleNewTripClose = _ => this.setState({newTripOpen: false});
    handleDetailClose = _ => this.setState({detailTrip: null});

    handlePageRequest = page => {
        const staffIds = (this.props.staffList || []).map(staff => staff.id_dipendente).filter(Boolean);
        if (!staffIds.length) {
            return Promise.resolve({data: [], total: 0, max_items: 1, pages: 1, prev: null, next: null});
        }
        return ModuloHRAPI.AwayTrips.pagination(staffIds, page);
    }

    handleTripCreated = staffId => {
        this.setState({newTripOpen: false, selectedStaffId: staffId || this.state.selectedStaffId}, this.resetPaginator);
    }

    handleTripDeleted = _ => {
        this.resetPaginator();
    }

    handleTripOpen = item => {
        const staff = this.getStaffById(item.id_dipendente);
        this.setState({detailTrip: {trip: item, staff: staff}});
    }

    renderItem = (item, index) => {
        const staff = this.getStaffById(item.id_dipendente);
        return (
            <AwayTripListItem
                key={item.trip_id || index}
                item={item}
                staff={staff}
                onOpen={this.handleTripOpen}
            />
        );
    }

    renderEmptyPage = _ => {
        return (
            <div className={"container text-center text-muted py-4"}>
                Non ci sono trasferte.
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={"container py-3 d-flex align-items-center justify-content-end"}>
                    <button
                        type={"button"}
                        className={"btn btn-primary"}
                        onClick={this.handleNewTripOpen}
                    >
                        Nuova trasferta
                    </button>
                </div>

                <div className={"container pb-4"}>
                    <FuxOffsetPaginator
                        ref={this.paginatorRef}
                        onPageRequest={this.handlePageRequest}
                        onItemRender={this.renderItem}
                        onEmptyPage={this.renderEmptyPage}
                        classItemsContainer={"list-group"}
                        visiblePagesCount={5}
                    />
                </div>

                <ModalPortalHOC>
                    {
                        this.state.newTripOpen &&
                        <NewAwayTripPage
                            staffList={this.props.staffList}
                            selectedStaffId={this.state.selectedStaffId}
                            active={this.state.newTripOpen}
                            onDismiss={this.handleNewTripClose}
                            onTripCreated={this.handleTripCreated}
                        />
                    }
                    {
                        this.state.detailTrip &&
                        <AwayTripDetailPage
                            trip={this.state.detailTrip.trip}
                            staff={this.state.detailTrip.staff}
                            staffList={this.props.staffList}
                            active={!!this.state.detailTrip}
                            onDismiss={this.handleDetailClose}
                            onDeleted={this.handleTripDeleted}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

AwayTripsTab.propTypes = {
    staffList: PropTypes.array
};
